import React from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'

const AnDatePicker = ({ label, date, onChange, openTo, ...props }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en-gb">
      <DatePicker
        desktopmodemediaquery="@media (min-width:0px)"
        label={label}
        openTo={openTo ?? 'year'}
        views={['year', 'month', 'day']}
        value={date ? moment(date) : null}
        onChange={onChange}
        {...props}
        slotProps={{
          textField: {
            size: props.size,
            fullWidth: props.fullWidth,
            error: props.error,
            required: props.required,
          },
        }}
      />
    </LocalizationProvider>
  )
}

export default AnDatePicker
